import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'fms-card-footer',
	templateUrl: 'card-footer.component.html',
	styles: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [],
})
export class CardFooterComponent {}
